import {
  INITIAL_API,
  PENDING,
  COMPLETED,
  FAILED,
} from "src/engine/modules/constants"
import get from "lodash/get"
import { showToast } from "@infotech/uikit-toasts"
import {
  REQUESTED_API_ENTITY,
  REQUESTED_API_ENTITY_SUCCEEDED,
  REQUESTED_API_ENTITY_FAILED,
  REQUESTED_API_ENTITY_LIST,
  REQUESTED_API_ENTITY_LIST_FAILED,
  REQUESTED_API_ENTITY_LIST_SUCCEEDED,
} from "../actions/types"

export default function apiReducer(state = INITIAL_API, action) {
  // read entity
  switch (action.type) {
    case REQUESTED_API_ENTITY: {
      const entityName = get(action, `config.name`)
      return {
        ...state,
        [entityName]: {
          ...state[entityName],
          one: {
            status: PENDING,
            data: {},
          },
        },
      }
    }
    case REQUESTED_API_ENTITY_SUCCEEDED: {
      const entityData = get(action, `response.data`)
      const entityName = get(action, `action.config.name`)
      return {
        ...state,
        [entityName]: {
          ...state[entityName],
          one: {
            status: COMPLETED,
            data: entityData,
          },
        },
      }
    }
    case REQUESTED_API_ENTITY_FAILED: {
      showToast({
        type: `error`,
        message: get(action, `error.response.data.exception`),
        hideIn: 5,
      })
      const entityName = get(action, `config.name`)
      return {
        ...state,
        [entityName]: {
          ...state[entityName],
          one: {
            ...state[entityName].one,
            status: FAILED,
          },
        },
      }
    }
    // read list
    case REQUESTED_API_ENTITY_LIST: {
      const entityName = get(action, `config.name`)
      return {
        ...state,
        [entityName]: {
          ...state[entityName],
          list: {
            status: PENDING,
            data: [],
          },
        },
      }
    }
    case REQUESTED_API_ENTITY_LIST_SUCCEEDED: {
      const entityData = get(action, `response.data`)
      const entityName = get(action, `action.config.name`)
      return {
        ...state,
        [entityName]: {
          ...state[entityName],
          list: {
            status: COMPLETED,
            data: entityData,
          },
        },
      }
    }
    case REQUESTED_API_ENTITY_LIST_FAILED: {
      showToast({
        type: `error`,
        message: get(action, `error.response.data.exception`),
        hideIn: 5,
      })
      const entityName = get(action, `config.name`)
      return {
        ...state,
        [entityName]: {
          ...state[entityName],
          list: {
            ...state[entityName].list,
            status: FAILED,
          },
        },
      }
    }
    default:
      return state
  }
}
